export default __webpack_public_path__ + "static/media/mtel.96f7b86e.png";